/**
 * Threads of the day timeline and of the territory: an SVG path drawn as a visible window [a, b] of its
 * length (fractions 0..1), plus a short solar tip riding the drawing front, like the
 * golden tips of the fiber field.
 *
 * The window lives in data attributes (data-a: tail, data-b: head) so it survives React
 * re-renders (the paths are recomputed on resize) and is repainted in real pixels from
 * the current length. The default markup is the final state: data-a="0", data-b="1".
 */
const TIP = 9;

export function paintThread(thread: SVGPathElement): void {
	const length = thread.getTotalLength();
	if (!length) return;
	const a = Number(thread.dataset.a || 0);
	const b = Number(thread.dataset.b || 0);
	const gap = length * 2 + 2;

	const visible = Math.max(0, (b - a) * length);
	thread.style.strokeDasharray = `${visible} ${gap}`;
	thread.style.strokeDashoffset = `${-a * length}`;
	thread.style.opacity = visible > 0.5 ? '1' : '0';

	const tip = thread.nextElementSibling;
	if (tip instanceof SVGPathElement) {
		const head = b * length;
		const size = Math.min(TIP, head);
		tip.style.strokeDasharray = `${size} ${gap}`;
		tip.style.strokeDashoffset = `${-(head - size)}`;
		tip.style.opacity = head > 0.5 ? '1' : '0';
	}
}

/** Write a window and repaint. */
export function setThread(thread: SVGPathElement, a: number, b: number): void {
	thread.dataset.a = String(a);
	thread.dataset.b = String(b);
	paintThread(thread);
}

/** Back to the final state (used when an animated mode is torn down). */
export function resetThreads(root: ParentNode): void {
	root.querySelectorAll<SVGPathElement>('[data-day-thread], [data-territory-thread]').forEach((thread) => setThread(thread, 0, 1));
}
